import gql from "graphql-tag";

const setNewPasswordMutation = gql`
  mutation setNewPassword($token: String!, $newPassword: String!) {
    partnerUser {
      resetPassword(input: { token: $token, newPassword: $newPassword }) {
        output {
          id
        }
      }
    }
  }
`;

export default setNewPasswordMutation;
